import script from "./button-widget-ly.vue?vue&type=script&setup=true&lang=js"
export * from "./button-widget-ly.vue?vue&type=script&setup=true&lang=js"

import "./button-widget-ly.vue?vue&type=style&index=0&id=5955c39a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5955c39a"]])

export default __exports__